export default __webpack_public_path__ + "static/media/hop05.2c27786e.png";